module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp1_7005.db1e1c68.png";